import { HashRouter,BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from './Components/HomePage/Home';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect } from 'react';
// import useAuthTokenCheck from './_services/authToken';
import './responsive.css';
import ProductDetail from './Components/ProductDetail';
import ShippingAddress from './Components/ShippingAddress';
import Login from './Components/Login';
import Cart from './Components/Cart';
import UserRegister from './Components/UserRegister';
import Checkout from './Components/Checkout';
import ForgotPassword from './Components/ForgotPassword';
import SubCategory from './Components/ProductSubCategory';
import ProductBySubCategoryId from './Components/ProductsBySubcategoryId';
import Products from './Components/Products';
import ContactUs from './Components/ContactUs';
import { WishlistProvider } from './context/wishlistContext';
import Wishlist from './Components/Wishlist';
import AboutUs from './Components/AboutUs';
import PaymentReturn from './Components/PaymentReturn';
import PrivacyPolicy from './Components/PrivacyPolicy';
import RefundandReturnPolicy from './Components/RefundandReturnPolicy';
import TermsConditions from './Components/TermsConditions';
import FAQAccordion from './Components/Faq';
import Blog from './Components/Blog';
import YourOrder from './Components/YourOrders';
import CancelOrder from './Components/Shared/CancelOrder';
import MyProfile from './Components/MyProfile';
import SizeChart from './Components/SizeChart';
import useAuthTokenCheck from './_services/authToken';
import SearchPage from './Components/Shared/SearchPage';

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem("isLoggedIn");
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  return element;
};

function App() {
  const { checkTokenAndHandleExpiration } = useAuthTokenCheck();

  useEffect(() => {
    checkTokenAndHandleExpiration(); 
  }, [checkTokenAndHandleExpiration]);

  return (
    <WishlistProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:name/:name/:name/:id" element={<ProductDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<UserRegister />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/:name" element={<SubCategory />} />
          <Route path="/:name/:name" element={<ProductBySubCategoryId />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-and-return-policy" element={<RefundandReturnPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/faqs" element={<FAQAccordion />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/sizechart" element={<SizeChart />} />
          <Route path="/search" element={<SearchPage />} />

          {/* secure routes */}
          <Route path="/shipping-address" element={<ProtectedRoute element={<ShippingAddress />} />} />
          <Route path="/checkout" element={<ProtectedRoute element={<Checkout />} />} />
          <Route path="/wishlist" element={<ProtectedRoute element={<Wishlist />} />} />
          <Route path="/paymentreturn/:id" element={<ProtectedRoute element={<PaymentReturn />} />} />
          <Route path="/your-orders" element={<ProtectedRoute element={<YourOrder />} />} />
          <Route path="/my-profile" element={<ProtectedRoute element={<MyProfile />} />} />
          <Route path="/cancel-order/:id" element={<ProtectedRoute element={<CancelOrder />} />} />
        </Routes>
      </BrowserRouter>
    </WishlistProvider>
  );
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

export default App;
